import * as ReactDOM from "react-dom";
import * as React from "react";
import withDraggablePopup from './withDraggablePopup';
import { Label, DynamicLabel } from './FormControl'

class PopupHelp {

  constructor(index, componentInstanceArray) {
    this.index = index;
    this.componentInstanceArray = componentInstanceArray;
  }

  openWindow = (props) => {
    this.componentInstanceArray[this.index].openWindow(props);
  }
  closeWindow = (props) => {
    this.componentInstanceArray[this.index].closeWindow(props);
  }
}

export class PopupManager extends React.Component {

  childComponentList = {}
  componentInstanceArray = [];
  componentProps = [];

  constructor(props) {
    super(props);

  }

  createPopup = (CustomComponent, title, props) => {
    //console.log("this.childComponentList", title);
    const childComponentList = this.childComponentList;
    var targetURL = window.location.hash;


    const ContentComponent = withDraggablePopup(CustomComponent, {
      title: <Label>{title}</Label>,
      ...props
    })

    if (!childComponentList[targetURL]) childComponentList[targetURL] = [];

    childComponentList[targetURL].push(ContentComponent);

    //reset component list when page changed
    for (var url in childComponentList) {
      if (url != targetURL && childComponentList[url].length) {
        childComponentList[url].length = 0;
        delete childComponentList[url];
      }
    }



    let index = childComponentList[targetURL].length - 1;
    this.componentProps[index] = props;

    this.setState({});

    // console.log("this.childComponentList", this.childComponentList)

    return new PopupHelp(index, this.componentInstanceArray);

  }


  render() {
    const childComponentList = this.childComponentList;


    return (

      <React.Fragment>
        {childComponentList[window.location.hash] && childComponentList[window.location.hash].map((Element, index) => {
          let props = this.componentProps[index];
          return (
            <Element
              {...props}
              key={index}
              ref={(input) => {

                this.componentInstanceArray[index] = input;
              }}
            >
            </Element>
          );
        })}
      </React.Fragment>

    );
  }

}

export class GlobalPopupManager extends React.Component {

  childComponentList = {}
  componentInstanceArray = [];
  componentProps = [];

  constructor(props) {
    super(props);

  }

  createPopup = (CustomComponent, title, props, specialURL) => {
    // //console.log("this.childComponentList", title);
    const childComponentList = this.childComponentList;
    var targetURL = "Global";

    const ContentComponent = withDraggablePopup(CustomComponent, {
      title: <Label>{title}</Label>,
      ...props
    })

    if (!childComponentList[targetURL]) childComponentList[targetURL] = [];

    childComponentList[targetURL].push(ContentComponent);

    //reset component list when page changed
    // for (var url in childComponentList) {
    //   if (url != targetURL && childComponentList[url].length) {
    //     childComponentList[url].length = 0;
    //     delete childComponentList[url];
    //   }
    // } 

    let index = childComponentList[targetURL].length - 1;
    this.componentProps[index] = props;

    this.setState({});

    // console.log("this.childComponentList", this.childComponentList)

    return new PopupHelp(index, this.componentInstanceArray);

  }


  render() {
    const childComponentList = this.childComponentList;


    return (

      <React.Fragment>
        {childComponentList["Global"] && childComponentList["Global"].map((Element, index) => {
          let props = this.componentProps[index];
          return (
            <Element
              {...props}
              key={index}
              ref={(input) => {

                this.componentInstanceArray[index] = input;
              }}
            >
            </Element>
          );
        })}
      </React.Fragment>

    );
  }

}



// WEBPACK FOOTER //
// ./src/components/PopupManager.js